import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec79d52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stick-card" }
const _hoisted_2 = { class: "d-flex flex-column justify-space-between" }
const _hoisted_3 = { class: "d-flex justify-space-between title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.name) + " (coming soon)", 1),
        _hoisted_4
      ]),
      _createElementVNode("img", {
        src: '/assets/cue-sticks/' + _ctx.file + '.png',
        alt: `${_ctx.name} image`,
        class: "image"
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.stats), (statName) => {
          return (_openBlock(), _createElementBlock("div", {
            key: statName,
            class: "d-flex align-center justify-space-between"
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(statName), 1),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: _normalizeClass([{ point: i <= _ctx.stats[statName] }, "point-placeholder"])
                }, null, 2)
              }), 64))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('use', _ctx.id))),
        class: _normalizeClass([{ used: _ctx.isUsed }, "btn"])
      }, _toDisplayString(_ctx.buttonText), 3)
    ])
  ]))
}